import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Tooltip } from '@mentimeter/ragnar-ui/tooltip';
import { GlobeIcon, LockIcon } from '@mentimeter/ragnar-visuals';
import { useSuspenseFlag } from '@mentimeter/flags/confidence/client';

const ShareButton = (buttonProps: Omit<ButtonT, 'children'>) => {
  return (
    <Button size="compact" {...buttonProps}>
      Share
    </Button>
  );
};

interface HeaderShareButtonProps extends Omit<ButtonT, 'children'> {
  resultSharing?: string | undefined;
}

const getShareButtonIcon = (
  resultSharing: string | undefined,
  showNewShareModalDesign: boolean,
) => {
  if (!showNewShareModalDesign) return undefined;

  return resultSharing === 'off' ? LockIcon : GlobeIcon;
};

const getTooltipText = (iconLeading: typeof GlobeIcon | typeof LockIcon) => {
  return iconLeading === LockIcon
    ? 'Only invited collaborators can access this Menti'
    : 'Anyone with the link can access this Menti';
};

export const HeaderShareButton = ({
  resultSharing,
  ...buttonProps
}: HeaderShareButtonProps) => {
  const { value: showNewShareModalDesign } = useSuspenseFlag(
    'bees-share-modal-redesign.enabled',
    false,
  );

  const iconLeading = getShareButtonIcon(
    resultSharing,
    showNewShareModalDesign,
  );
  const tooltip = iconLeading ? getTooltipText(iconLeading) : undefined;

  return showNewShareModalDesign && tooltip ? (
    <Tooltip
      trigger={<ShareButton {...buttonProps} iconLeading={iconLeading} />}
    >
      {tooltip}
    </Tooltip>
  ) : (
    <ShareButton {...buttonProps} />
  );
};
